module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/get-prototype-of"
// module id = 11
// module chunks = 0